module.exports = __webpack_public_path__ + "img/vi.4952d5bf.svg";